import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import FrankExampleSwedish from "@/assets/frank-example-swedish.png";
import FrankExampleEnglish from "@/assets/frank-example-english.png";

const CTASection = () => {
  const navigate = useNavigate();
  const { t, language } = useLanguage();
  
  const frankExampleImage = language === 'sv' ? FrankExampleSwedish : FrankExampleEnglish;
  
  return (
    <section className="bg-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A237E] mb-12">
            {t('cta.title')}
          </h2>
          
          {/* Frank Example Image */}
          <div className="mb-8 flex justify-center">
            <div className="max-w-3xl w-full">
              <img 
                src={frankExampleImage}
                alt={language === 'sv' ? 'Exempel på Franks svar på svenska' : 'Example of Frank\'s answer in English'}
                className="w-full h-auto rounded-lg shadow-lg"
                loading="lazy"
              />
            </div>
          </div>
          
          <div className="text-center">
            <Button size="lg" onClick={() => navigate('/auth')} className="bg-[#1A237E] hover:bg-[#673AB7] text-white px-8 py-3 text-lg">
              {t('cta.button')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;